export const POST_PATH = "posts"
export const TAMDA_MEDIA_SETTING_PATH = "tamda-media-eu-setting"
export const YOUTUBE_VIDEO_PATH = "youtube-videos"
export const YOUTUBE_VIDEO_PATH_SYNC = "youtube-videos/sync"
export const BATCH_PATH = "batch"
export const BANNER_PATH="banners"
